import { FormControl, FormGroup } from '@angular/forms';

import { FileForm } from './file-form';

export class ProposalRequestFileForm extends FormGroup<{
  id: FormControl<undefined | number>;
  ProposalRequestId: FormControl<undefined | number>;
  FileId: FormControl<undefined | number>;

  File: FileForm;
}> {
  constructor() {
    super({
      id: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      ProposalRequestId: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      FileId: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),

      File: new FileForm()
    });
  }
}
